import { useState, useEffect, useMemo, useContext } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import _ from "underscore";
import { formJson } from "../../../utils/formJson";
import { useCommanKit } from "./useCommanKit";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, toLocalDateString } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";

export const useProvidentFundDeclaration = ({ label, data, onNext, readOnly }) => {
    const { showSuccess, showError } = useContext(ToastContext)
    const { fieldData, getDataKey } = formJson?.[label];
    const { getEmployeeDetails } = useCommanKit({ data });
    const [formValues, setFormValues] = useState({})
    const [janKYC, setJanKYC] = useState([]);
    const [uanKYC, setUanKYC] = useState([]);
    const [isChange, setIsChanged] = useState(false);

    const [rowData, setRowData] = useState([
        { id: 0, field: "epf_declaration_id", label: "", type: "text", value: 0, group: "Basic Info" },
        { id: 1, field: "aadhar_name", label: "Name of Member (Aadhar Name)", type: "text", value: "", group: "Basic Info" },
        { id: 2, field: "relative_name", label: "Father's Name / Spouse's Name", type: "text", value: "", group: "Basic Info" },
        { id: 3, field: "date_of_birth", label: "Date of Birth (dd/mm/yyyy)", type: "date", value: null, group: "Basic Info" },
        {
            id: 4,
            field: "gender_item_id",
            label: "Gender",
            value: "",
            type: "dropdown",
            options: [],
            optionType: "gender",
            group: "Basic Info"
        },
        {
            id: 5,
            field: "marital_item_id",
            label: "Marital Status",
            value: "",
            type: "dropdown",
            options: [],
            optionType: "marital_status",
            group: "Basic Info"
        },
        { id: 6, field: "email_id", label: "Email ID", type: "text", value: "", group: "Contact Details" },
        { id: 7, field: "mobile_number", label: "Mobile No (Aadhar Registered)", type: "text", value: "", group: "Contact Details" },
        {
            id: 8,
            field: "is_epf_earlier_member",
            label: "Whether earlier member of Employee's Provident Fund Scheme, 1952?",
            value: false,
            type: "dropdown",
            options: [{ label: "Yes", value: true },
            { label: "No", value: false }],
            group: "Membership Details"
        },
        {
            id: 9,
            field: "is_pension_earlier_member",
            label: "Whether earlier member of Employee's Pension Scheme, 1995?",
            value: false,
            type: "dropdown",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false }
            ],
            group: "Membership Details"
        },
        { id: 10, field: "uan_number", label: "Previous Universal Account Number (UAN)", type: "text", value: "", group: "Previous Employment" },
        { id: 11, field: "pf_account_number", label: "Previous PF Account Number", type: "text", value: "", group: "Previous Employment" },
        { id: 12, field: "previous_employment_date", label: "Date of Exit from previous Employment (dd/mm/yyyy)", type: "date", value: "", group: "Previous Employment" },
        { id: 13, field: "scheme_certificate_number", label: "Scheme Certificate No (If issued)", type: "text", value: "", group: "Previous Employment" },
        { id: 14, field: "pension_payment_order", label: "Pension Payment Order (PPO) (If issued)", type: "text", value: "", group: "Previous Employment" },
        {
            id: 15,
            field: "international_worker",
            label: "International Worker?",
            value: false,
            type: "dropdown",
            options: [{ label: "Yes", value: true },
            { label: "No", value: false }],
            group: "International Work"
        },
        { id: 16, field: "country_name", label: "Country of Origin (If yes)", type: "text", value: "", group: "International Work" },
        { id: 17, field: "passport_number", label: "Passport No.", type: "text", value: "", group: "International Work" },
        { id: 18, field: "passport_validity_from", label: "Passport Validity From (dd/mm/yyyy)", type: "date", value: "", group: "International Work" },
        { id: 19, field: "passport_validity_to", label: "Passport Validity To (dd/mm/yyyy)", type: "date", value: "", group: "International Work" },
        { id: 20, field: "account_number", label: "Bank Account No.", type: "text", value: "", group: "KYC Details" },
        { id: 21, field: "bank_code", label: "IFSC Code", type: "text", value: "", group: "KYC Details" },
        { id: 22, field: "adhar_number", label: "Aadhar Number", type: "text", value: "", group: "KYC Details" },
        { id: 23, field: "pan_number", label: "PAN Number (If available)", type: "text", value: "", group: "KYC Details" }
    ]);


    const toggleSelection = (value, selectedArray, setSelected) => {
        setIsChanged(true)
        if (selectedArray.includes(value)) {
            setSelected(selectedArray.filter(item => item !== value));
        } else {
            setSelected([...selectedArray, value]);
        }
    };

    useEffect(() => {
        const newRowData = rowData.map((field) => {
            if (field.type === "dropdown" && field.optionType) {
                const group = _.find(data?.attributeGroup, { attribute_group_key: field.optionType });
                if (group) {
                    const options = _.filter(data?.attributeItems, { attribute_group_id: group.attribute_group_id }).map((item) => ({
                        label: item.item_name,
                        value: item.attribute_item_id
                    }));
                    return { ...field, options };
                }
            }
            return field;
        });
        setRowData(newRowData);
    }, [data]);


    const onValueChange = (e, row) => {
        setIsChanged(true)
        let value;
        if (row.type === "checkbox") {
            value = e.checked;
        } else if (row.type === "date") {
            value = e.value;
        } else {
            value = e.target ? e.target.value : e.value;
        }
        setRowData((curr) =>
            curr.map((r) => (r.id === row.id ? { ...r, value } : r))
        );
    };

    useEffect(() => {
        callAPI()
    }, [data?.employee?.user_code]);

    const callAPI = () => {
        if (!data?.employee?.user_code) return;

        getEmployeeDetails(getDataKey, data?.employee?.user_code).then((res) => {

            // Update formValues from API
            Object.entries(fieldData).forEach(([sectionName, sectionObj]) => {
                setFormValues((prev) => {
                    const sectionData = res?.[sectionObj.key] || [];
                    return {
                        ...prev,
                        [sectionName]: sectionData,
                    };
                });
            });
            setRowData((prevRows) =>
                prevRows.map((row) => {
                    let valueFromAPI = null;
                    const sectionData = res?.employee_pf_organisation_details;

                    if (Array.isArray(sectionData) && sectionData.length > 0) {
                        const possibleValue = sectionData[0][row.field];
                        if (possibleValue !== undefined) {
                            valueFromAPI = possibleValue;
                        }
                    } else if (sectionData && sectionData[row.field] !== undefined) {
                        valueFromAPI = sectionData[row.field];
                    }
                    if (
                        row.type === "date" &&
                        valueFromAPI &&
                        (typeof valueFromAPI === "string" || typeof valueFromAPI === "number")
                    ) {
                        valueFromAPI = new Date(valueFromAPI);
                    }

                    return { ...row, value: valueFromAPI ?? row.value };
                })
            );

            setJanKYC(prev => {
                const newValues = [];
                if (res?.employee_pf_organisation_details[0]?.is_not_uploaded) newValues.push("is_not_uploaded");
                if (res?.employee_pf_organisation_details[0]?.is_uploaded_but_not_approved) newValues.push("is_uploaded_but_not_approved");
                if (res?.employee_pf_organisation_details[0]?.is_uploaded_and_approved_dsc) newValues.push("is_uploaded_and_approved_dsc");
                return [...prev, ...newValues];
            });
            setUanKYC(prev => {
                const newValues = [];
                if (res?.employee_pf_organisation_details[0]?.is_kyc_approved_with_dsc) newValues.push("is_kyc_approved_with_dsc");
                if (res?.employee_pf_organisation_details[0]?.is_not_registered_with_epfo) newValues.push("is_not_registered_with_epfo");
                return [...prev, ...newValues];
            });
        });
    };


    const valueBodyTemplate = (rowData) => {
        switch (rowData.type) {
            case "text":
                return (
                    <>
                        {
                            readOnly ? rowData?.value : <InputText
                                value={rowData.value || ""}
                                onChange={(e) => onValueChange(e, rowData)}
                                className="p-inputtext-sm"
                                style={{ width: "100%" }}
                            />
                        }
                    </>

                );
            case "dropdown":
                return (
                    <>
                        {
                            readOnly ? 
                            (rowData?.field === "gender_item_id" || rowData?.field === "marital_item_id") ? _.find(rowData.options, { value: rowData?.value })?.label : rowData?.value ? "yes" : "No"
                             :
                             <Dropdown
                                options={rowData.options || []}
                                value={rowData.value}
                                onChange={(e) => onValueChange(e, rowData)}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select"
                                className="p-inputtext-sm"
                                style={{ width: "100%" }}
                            />
                        }
                    </>

                );
            case "date":
                return (
                    <div className="inspectra-calendar">
                        {
                            readOnly ? dateConvert(rowData.value, "day-mon-year") : <Calendar
                                value={rowData.value}
                                onChange={(e) => onValueChange(e, rowData)}
                                className="input-dd"
                                dateFormat="dd-mm-yy"
                                style={{ width: "40%" }}
                            />
                        }

                    </div>
                );
            case "checkbox":
                return (
                    <Checkbox
                        inputId={`chk-${rowData.id}`}
                        checked={!!rowData.value}
                        onChange={(e) => onValueChange(e, rowData)}
                    />
                );
            default:
                return rowData.value || "";
        }
    };

    const columnDefs = [
        {
            header: "",
            field: "group",
            style: { fontWeight: "bold" },
            headerStyle: { width: "60px" },
            hide:readOnly,
        },
        {
            header: "",
            field: "label",
            style: { width: "300px" },
            headerStyle: { width: "300px" }
        },
        {
            header: "",
            field: "value",
            body: valueBodyTemplate,
            style: { width: "400px" },
            headerStyle: { width: "400px" }
        }
    ]

    const getPayload = () => {
        const payload = {};
        rowData.forEach(({ field, value }) => {
            if (value instanceof Date) {
                payload[field] = toLocalDateString(value);;
            } else {
                payload[field] = value;
            }
        });
        payload.epf_declaration_id = 1;
        payload.is_not_uploaded = janKYC.includes("is_not_uploaded");
        payload.is_uploaded_but_not_approved = janKYC.includes("is_uploaded_but_not_approved");
        payload.is_uploaded_and_approved_dsc = janKYC.includes("is_uploaded_and_approved_dsc");
        payload.is_kyc_approved_with_dsc = uanKYC.includes("is_kyc_approved_with_dsc");
        payload.is_not_registered_with_epfo = uanKYC.includes("is_not_registered_with_epfo");
        return payload;
    }

    const submitProvidentFundDeclaration = async () => {
        try {
            if (!isChange) {
                onNext();
                return
            }
            const payload = getPayload();
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEEPFORGANISATIONDATA"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                onNext();
            } else {
                showError("error", res?.body?.errorMessage);
            }
        } catch (error) {
            console.error("API call failed:", error);
        }
    }


    return useMemo(() => ({
        rowData, columnDefs, fieldData, callAPI, submitProvidentFundDeclaration, toggleSelection, formValues, janKYC, setJanKYC, uanKYC, setUanKYC
    }), [rowData, columnDefs, fieldData, callAPI, submitProvidentFundDeclaration, toggleSelection, formValues, janKYC, setJanKYC, uanKYC, setUanKYC])
};
